import * as React from "react";
import { twMerge } from "tailwind-merge";
import Chip, { type ChipType } from "./Chip";
import Text from "./Text";

export type AlertType = "info" | "secondary";

export type AlertProps = {
  title: React.ReactNode;
  badge?: string;
  type?: AlertType;
  className?: string;
};

const typeClass: Record<AlertType, string> = {
  info: "border-border bg-background text-text-primary",
  secondary: "border-transparent bg-secondary text-text-surface",
};

const badgeChipType: Record<AlertType, ChipType> = {
  info: "secondary",
  secondary: "primary",
};

export default function Alert({
  title,
  badge,
  type = "info",
  className,
}: AlertProps) {
  return (
    <div
      role="status"
      className={twMerge(
        "rounded-[6px] border p-[12px]",
        badge && "flex flex-col items-start gap-[8px]",
        typeClass[type],
        className,
      )}
    >
      {badge && (
        <Chip label={badge} type={badgeChipType[type]} solid />
      )}
      <Text className={twMerge(!badge && "text-center")}>{title}</Text>
    </div>
  );
}
